const axios = require('axios')
const request = require('browser-request')
const queryString = require('query-string')

class GatewaySDK {
  constructor (options, app) {
    this.url = options.url
    this.url23 = options.url23
    this.optHost = options.optimizationHost.replace(/\/$/gi, '')
    this.app = app
  }

  get (vue, route, params, callback, version) {
    let qs = ''
    let self = this
    let v = '1.1'
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    if (Object.values(params).length > 0) {
      qs = '?' + queryString.stringify(params)
    }
    request.get({
      url: self.url + '/' + v + route + qs,
      json: true,
      body: params
    }, function (err, res, body) {
      if (err) throw err
      if (body.error) {
        try {
          if (body.error.message.endsWith('.')) body.error.message = body.error.message.slice(0, -1)
          body.error.message = vue.$t('backend.' + body.error.message)
        } catch (err) {
          body.error.message = body.error.message
        }
      }
      callback(body)
    })
  }

  post (vue, route, params, callback, version) {
    let self = this
    let v = '1.1'
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    request.post({
      url: self.url + '/' + v + route,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      if (body.error) {
        try {
          if (body.error.message.endsWith('.')) body.error.message = body.error.message.slice(0, -1)
          body.error.message = vue.$t('backend.' + body.error.message)
        } catch (err) {
          body.error.message = body.error.message
        }
      }
      callback(body)
    })
  }

  delete (vue, route, params, callback, version) {
    let self = this
    let v = '1.1'
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    request({
      method: 'DELETE',
      url: self.url + '/' + v + route,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      if (body.error) {
        try {
          if (body.error.message.endsWith('.')) body.error.message = body.error.message.slice(0, -1)
          body.error.message = vue.$t('backend.' + body.error.message)
        } catch (err) {
          body.error.message = body.error.message
        }
      }
      callback(body)
    })
  }

  opt (route, params, callback) {
    request.post({
      url: `${this.optHost}/${route.replace(/^\//gi, '')}`,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  post2 (url, params, callback) {
    let settings = {
      method: 'post',
      url: url,
      responseType: 'json',
      data: JSON.stringify(params),
      headers: {'Content-Type': 'application/json'}
    }
    axios(settings).then(r => {
      callback(r.data)
    }).catch(err => {
      let er = err
      if (err.response && err.response.status === 400) {
        er = err.response.data
      }
      callback({ error: er })
    })
  }

  get2 (url, params, callback) {
    request.get({
      url: url,
      json: true,
      body: params
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
    // let settings = {
    //   method: 'post',
    //   url: url,
    //   responseType: 'json',
    //   data: JSON.stringify(params),
    //   headers: {'Content-Type': 'application/json'}
    // }
    // axios(settings).then(r => {
    //   callback(r.data)
    // }).catch(err => {
    //   console.log(err)
    //   callback({ error: err })
    // })
  }

  post23 (vue, route, params, callback) {
    let self = this
    request.post({
      url: self.url23 + route,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      if (body.error) {
        try {
          if (body.error.message.endsWith('.')) body.error.message = body.error.message.slice(0, -1)
          body.error.message = vue.$t('backend.' + body.error.message)
        } catch (err) {
          body.error.message = body.error.message
        }
      }
      callback(body)
    })
  }
}

export default GatewaySDK



// WEBPACK FOOTER //
// ./src/modules/gateway-sdk/gateway-sdk.js